import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  ClipboardList,
  Shield,
  Mail
} from 'lucide-react';
import { cn } from '@/lib/core/utils';

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/admin/waitlist', icon: ClipboardList, label: 'Waitlist' },
  { to: '/admin/users', icon: Users, label: 'Users & Businesses' },
  { to: '/admin/email-templates', icon: Mail, label: 'Email Templates' },
];

const AdminSidebar: React.FC = () => {
  return (
    <aside className="w-64 bg-card border-r min-h-screen p-4">
      <div className="flex items-center gap-2 px-2 mb-8">
        <Shield className="h-6 w-6 text-primary" />
        <span className="font-semibold text-lg">Admin Panel</span>
      </div>

      <nav className="space-y-1">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              cn(
                'flex items-center gap-3 px-3 py-2 rounded-md text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-primary-foreground'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
